<template lang="pug">
div
  b-form-row
    b-col
      b-form-group.mb-0
        b-input-group(size="sm" )
          b-form-input(type="search", :placeholder="searchPlaceholder", :value="filters.search_text", @input="$store.commit('inbox_filters/setSearchText', $event)")
          b-input-group-append
            b-input-group-text
              search-icon.text-dark.icon-sm
    b-col(cols="auto")
      b-dropdown#drop-filters(size="sm", variant="light", no-caret, dropright, dropup, boundary="window", :menu-class="['filters-dropdown']")
        template(slot="button-content")
          filter-icon.icon-sm
          span.text-sm
            b-badge.ml-1(variant="primary", v-if="filtersCount > 0") {{ filtersCount }}
        b-dropdown-form
          b-form-checkbox(@change="$store.commit('inbox_filters/setUnread', $event)", :checked="filters.unread") Mostrar no leídos
          b-form-checkbox(v-if="forCases" @change="$store.commit('inbox_filters/setOutbound', $event)", :checked="filters.outbound") Mostrar casos outbound
          b-form-checkbox(v-if="!forCases" @change="$store.commit('inbox_filters/setOutbound', $event)", :checked="filters.outbound") Mostrar solo outbound
          b-form-checkbox(v-if="!forCases" @change="$store.commit('inbox_filters/setInbound', $event)", :checked="filters.inbound") Mostrar sólo inbound
          b-form-checkbox(v-if="!forCases" @change="$store.commit('inbox_filters/enableSearch', $event)", :checked="filters.enableSearch") Habilitar búsqueda en mensajes
        // CASE
        div(v-if="forCases")
          // STATUS
          b-dropdown-header Estado del caso
          b-dropdown-form
            b-form-checkbox(v-for="opt in statuses", :key="opt.value", @change="$store.commit('inbox_filters/setCaseStatus', {event: $event, value: opt.value})", :checked="filters.case_statuses.includes(opt.value)", v-if="opt.permission ? $can('read', opt.permission) : true") {{opt.text}}
          b-dropdown-header Buscar por etiqueta
            b-form-checkbox(@change="$store.commit('inbox_filters/setUnread', $event)", :checked="filters.unread") Mostrar no leídos
            b-form-checkbox(v-if="forCases" @change="$store.commit('inbox_filters/setOutbound', $event)", :checked="filters.outbound") Mostrar casos outbound
            b-form-checkbox(v-if="!forCases" @change="$store.commit('inbox_filters/setOutbound', $event)", :checked="filters.outbound") Mostrar sólo outbound
          // DATES
          b-dropdown-header Buscar por fecha
          b-dropdown-form
            date-range-picker.w-100.p-0.b-0(v-bind="calendarProps", v-model="pickedDate", :amaxDate="$moment().format('YYYY-MM-DD')", @update="datePicked")
              template(v-slot:input="picker")
                b-input-group(size="sm")
                  b-form-input.readonly-white(placeholder="Buscar por fecha...", :value="selectedDates", readonly)
                  b-input-group-append
                    b-input-group-text
                      calendar-icon.text-secondary.icon-sm(v-if="!selectedDates")
                      x-icon.icon-sm.hover-primary(v-else, @click.stop="datePicked(null)")

          b-dropdown-header Buscar por etiquetas
          b-dropdown-form
            v-select.small(
              :placeholder="!tags.length ? 'No hay etiquetas disponibles' : 'Buscar por etiqueta'",
              :options="tags.map(({ value }) => value)",
              :value="filters.tags",
              label="title",
              :multiple="true",
              :clearable="true",
              @input="setOnlyTags($event)",
              @change="getAdmins"
            )
        // CHAT
        div(v-else)
          // BOX
          b-dropdown-header Bandeja
          b-dropdown-form
            b-form-radio-group(:checked="filters.box", :options="boxes", stacked, @change="$store.commit('inbox_filters/setBox', $event)")
          // SEARCH TYPE
          b-dropdown-header Tipo de búsqueda
          b-dropdown-form
            v-select.small(:options="searchOptions", :clearable="false", :value="attributeSelected", label="name", :reduce="attribute => attribute.user_attribute_id", @input="$store.commit('inbox_filters/setUserAttributeId', $event)", @search:focus="getUserAttributes", style="min-width:250px;")
              template(slot="spinner", v-if="loadingUserAttributes")
                b-spinner.ml-2(small, variant="primary")
          // CHATS-DATES
          div(v-if="!forCases")
            b-dropdown-header Buscar por etiquetas
            b-dropdown-form
              v-select.small(
                :placeholder="!labels.length ? 'No hay etiquetas disponibles' : 'Buscar por etiqueta'",
                :options="labels.map(({ value }) => value)",
                :value="filters.labels",
                label="title",
                :multiple="true",
                :clearable="true",
                @input="setOnlyLabels($event)",
                @change="getAdmins"
              )

            b-dropdown-header Buscar por fecha
            b-dropdown-form
              date-range-picker.w-100.p-0.b-0(v-model="pickedDate", :amaxDate="$moment().format('YYYY-MM-DD')", @update="datePicked")
                template(v-slot:input="picker")
                  b-input-group(size="sm")
                    b-form-input.readonly-white(placeholder="Buscar por fecha...", :value="selectedDates", readonly)
                    b-input-group-append
                      b-input-group-text
                        calendar-icon.text-secondary.icon-sm(v-if="!selectedDates")
                        x-icon.icon-sm.hover-primary(v-else, @click.stop="datePicked(null)")
          b-dropdown-header Buscar en mensajes
        // ADMINS
        div(v-if="$can('read', 'filter-by-admin')")
          b-dropdown-header Agentes
          b-dropdown-form
            v-select.small(:placeholder="!parsedAdmins.length ? 'No hay admins disponibles' : 'Buscar por nombre o correo'", :multiple="true", :options="parsedAdmins.map(a => a.value)", :clearable="true", label="title", :value="filters.admins", @input="$store.commit('inbox_filters/setAdmins', $event)", :filterBy="filterAdminBy", style="min-width:250px;", @search:focus="getAdmins")
              template(slot="spinner", v-if="loadingAdmins")
                b-spinner.ml-2(small, variant="primary")
        // PLATFORMS
        b-dropdown-header Plataformas
        b-dropdown-form
          v-select.small(placeholder="Buscar plataforma", :multiple="true", :options="platforms.map(a => a.value)", :clearable="true", label="title", :value="filters.platforms", @input="$store.commit('inbox_filters/setPlatforms', $event)", style="min-width:250px;")
  .text-sm.text-secondary(v-if="forCases") Buscar por nombre, Id de caso o teléfono
</template>

<script>
import { createNamespacedHelpers, mapActions, mapMutations } from 'vuex'
import boxes from '../data/boxes'
import Days from '../data/days'
import Months from '../data/months'
import debounce from 'lodash.debounce'

const filtersController = createNamespacedHelpers('inbox_filters')
const accountController = createNamespacedHelpers('account')
const labelController = createNamespacedHelpers('label')
const tagController = createNamespacedHelpers('tag')
const platformController = createNamespacedHelpers('platform')

export default {
  data() {
    return {
      loadingAdmins: false,
      loadingUserAttributes: false,
      boxes,
      statuses: [
        {
          text: 'Abierto',
          value: 'open'
        },
        {
          text: 'En espera',
          value: 'on_hold'
        },
        {
          text: 'Cerrado',
          value: 'close',
          permission: 'closed-cases'
        }
      ],
      calendarProps: {
        timePicker: false,
        ranges: false,
        linkedCalendars: false,
        opens: 'right',
        drops: 'up',
        autoApply: true,
        parentEl: '#drop-filters',
        localeData: {
          applyLabel: 'Aplicar',
          cancelLabel: 'Cancelar',
          daysOfWeek: Days.daysShort,
          monthNames: Months.monthsShort,
          firstDay: 0
        }
      },
      pickedDate: {
        startDate: null,
        endDate: null
      }
    }
  },
  props: {
    forCases: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...filtersController.mapState({
      filters: (state) => {
        return {
          outbound: state.outbound,
          inbound: state.inbound,
          unread: state.unread,
          box: state.box,
          search_text: state.search_text,
          platforms: state.platforms,
          labels: state.labels,
          admins: state.admins,
          tags: state.tags,
          case_statuses: state.case_statuses,
          dates: state.dates,
          user_attribute_id: state.user_attribute_id,
          enableSearch: state.enableSearch
        }
      }
    }),
    ...filtersController.mapGetters(['filtersCount']),
    ...accountController.mapState({
      user_attributes: (state) => state.user_attributes,
      admins: (state) =>
        state.admins.map((a) => {
          return {
            text: `${a.email}`,
            value: {
              title: `${a.first_name} ${a.last_name} (${a.email})`,
              email: `${a.email}`,
              admin_id: a.admin_id
            }
          }
        })
    }),
    ...labelController.mapState({
      labels: (state) =>
        state.labels.map(({ name, label_id: labelId, account_id: accountId }) => {
          return {
            text: name,
            value: { title: name, label_id: labelId, account_id: accountId }
          }
        })
    }),
    ...tagController.mapState({
      tags: (state) =>
        state.tags.map(({ name, tag_id: tagId, account_id: accountId }) => {
          return {
            text: name,
            value: { title: name, tag_id: tagId, account_id: accountId }
          }
        })
    }),
    ...platformController.mapState({
      platforms: (state) =>
        state.platforms.map((p) => {
          return {
            text: p.title,
            value: {
              title: p.title,
              platform_id: p.platform_id,
              name: p.name
            }
          }
        })
    }),
    parsedAdmins() {
      this.admins.unshift({
        text: 'Sin asignar',
        value: {
          title: 'Sin asignar',
          email: '',
          admin_id: 'null'
        }
      })

      return this.admins
    },
    searchPlaceholder() {
      const { filters } = this

      if (filters.enableSearch) return 'Buscar en conversaciones...'
      if (filters.user_attribute_id < 0) return 'Buscar en conversaciones...'
      else if (filters.user_attribute_id > 0) return 'Buscar por variable...'

      return 'Buscar usuarios...'
    },
    selectedDates() {
      if (!this.pickedDate.startDate || !this.pickedDate.endDate) return ''

      return (
        this.$moment(this.pickedDate.startDate).format(
          'DD MMM YYYY - hh:mm A'
        ) +
        ' - ' +
        this.$moment(this.pickedDate.endDate).format('DD MMM YYYY - hh:mm A')
      )
    },
    searchOptions() {
      const options = [
        {
          name: 'Buscar por usuario',
          user_attribute_id: 0
        }
        /* {
          name: 'Buscar mensajes en conversaciones',
          user_attribute_id: -1
        }, */
      ]

      return options.concat(this.user_attributes)
    },
    attributeSelected() {
      return this.searchOptions.find(
        (element) => element.user_attribute_id === this.filters.user_attribute_id
      )
    }
  },
  methods: {
    ...mapActions([
      'account/admins',
      'account/userAttributes',
      'platform/all'
    ]),
    ...mapMutations('inbox_filters', ['setOnlyLabels', 'setOnlyTags']),
    getAccountPlatforms() {
      const self = this

      this['platform/all']({
        account_id: self.$route.params.account_id
      })
    },
    getAdmins() {
      const self = this
      this.loadingAdmins = true

      this['account/admins']({
        account_id: self.$route.params.account_id,
        callback: (res) => {
          self.loadingAdmins = false

          if (res.error) return self.$message.error(res.error)
        }
      })
    },
    getUserAttributes() {
      if (this.user_attributes.length) return

      const self = this
      this.loadingUserAttributes = true

      this['account/userAttributes']({
        account_id: self.$route.params.account_id,
        callback: (res) => {
          this.loadingUserAttributes = false

          if (res.error) return self.$message.error(res.error)
        }
      })
    },
    updateInput: debounce(
      function (event) {
        this.$store.commit('inbox_filters/setSearchText', event)
      }, 500, { trailing: true, leading: true }
    ),
    filterAdminBy(option, label, search) {
      return (
        (option.title || '').toLowerCase().indexOf(search.toLowerCase()) > -1 ||
        (option.email || '').toLowerCase().indexOf(search.toLowerCase()) > -1
      )
    },
    datePicked(dates) {
      this.$store.commit('inbox_filters/setDates', dates)

      if (!dates) {
        this.pickedDate.startDate = null
        this.pickedDate.endDate = null
      }
    }
  },
  mounted() {
    this.$store.commit('inbox_filters/resetAllFilters')

    this.getAdmins()
    this.getAccountPlatforms()
  }
}
</script>

<style lang="scss" scoped></style>
